import { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { cn } from '@/utils/utils';
import { useStore } from '@/hooks/useStore';
import FooterPageForm from '@/components/layout/footer/FooterPageForm';
import { ROUTES } from '@/configs/constants';
import bgImage from '@/assets/images/eu-form-bg.jpg';
import { isPathEk } from '@/utils/routes';
import ScrollToTop from '@/components/general/ScrollToTop';
import { Logo } from '@/components/general/logo/Logo';
import { flowResult } from 'mobx';

export default observer(function FormPanelLayout() {
    // hook
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);
    const isRegistrationStep2 = pathname.includes(ROUTES.signup2.href);

    // store
    const {
        uiStore: {
            windowSize,
            devicesScreen
        },
        authStore: { verifyToken }
    } = useStore();

    const {
        desktop
    } = devicesScreen;

    // state
    const minHeightContent: number = useMemo(() => {
        let heightHeader: number = 0, heightFooter: number = 4.890625;

        return heightHeader + heightFooter;
    }, [devicesScreen, windowSize]);

    useEffect(() => {
        onVerifyToken();
    }, []);

    // function
    const onVerifyToken = async () => {
        await flowResult(verifyToken());
    };

    return (
        <>
            <div
                style={{ backgroundImage: `url(${bgImage})` }}
                className='bg-no-repeat bg-cover bg-center'
            >

                <section
                    className={cn(
                        desktop && 'px-4'
                    )}
                >
                    <div
                        className='container flex justify-center items-center'
                        style={{ minHeight: `calc(100vh - ${minHeightContent}rem)` }}
                    >
                        <div className='flex justify-center items-center h-full w-full pt-4'>
                            <div className={cn(
                                'bg-white rounded-base xsm:w-[480px] sm:w-[600px] lg:w-[680px] w-full px-6 py-8 xsm:shadow-shadow-1',
                                isRegistrationStep2 ? (isEk ? 'lg:w-[860px]' : 'lg:w-[1000px]') : ''
                            )}
                            >
                                <div className='flex justify-center mb-6'>
                                    <div className='logo w-[min(216px,45vw)]'>
                                        <Logo />
                                    </div>
                                </div>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </section>

                <section className='pt-9'>
                    <FooterPageForm />
                </section>

            </div>

            <ScrollToTop />
        </>
    );
});
